// extracted by mini-css-extract-plugin
export var resultItem = "search-navigation--result-item--cd6f7";
export var resultItemPath = "search-navigation--result-item-path--c48a9";
export var resultItemTitle = "search-navigation--result-item-title--25492";
export var resultSection = "search-navigation--result-section--b0a96";
export var results = "search-navigation--results--f3761";
export var searchBar = "search-navigation--search-bar--fb0e2";
export var searchField = "search-navigation--search-field--0c857";
export var searchFieldHotkey = "search-navigation--search-field-hotkey--04cc1";
export var searchModal = "search-navigation--search-modal--a41f9";
export var searchOverlay = "search-navigation--search-overlay--c8ab5";
export var selected = "search-navigation--selected--e6a88";
export var shown = "search-navigation--shown--19087";